<div>
  <div class="modal fade show" tabindex="-1" aria-labelledby="business-partners-modalLabel" aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
    [ngClass]="{'expanded':isExpanded}">

    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header float-end">
          <div class="d-flex w-100">
            <div class="me-2 flex-fill">
              <h2 class="modal-title mb-0 item-id">{{ config.appName === 'sales' ? 'Sales Representatives' : 'Select Reporter' }}</h2>
            </div>
            <div class="btns-header">
              <button class="header-icon close p-0 m-0" (click)="close()" aria-label="Close">
                  <i class="fas fa-times" title="Close Popup"></i>
              </button>
              <button class="header-icon close p-0 m-0" (click)="expandCollapse()" aria-label="Close">
                  <i class="fas mx-2" title="Close Popup"
                      [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}"
                      [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"></i>
              </button>
            </div>
          </div>
        </div>




        <div class="modal-body pt-0">
          <div class="row header-section px-3 pt-1"
            [ngStyle]="{'display': 'block', 'overflow':'auto', 'min-height':'530px', 'max-height':'530px'}">

            <div class="w-100">
              <ejs-grid #AddressesPopupGrid id="AddressesPopupGrid" [dataSource]="allAddressesData"
                [height]="'380px'" [gridLines]="false" [allowFiltering]="true" [allowPaging]="true"
                [searchSettings]="searchSettings" [pageSettings]="pageSettings" [allowSorting]="true" [enableHover]="false" [allowResizing]="true" [allowReordering]="true" [showColumnChooser]="true" [allowExcelExport]="true" [allowSelection]="true" [editSettings]="{ allowEditing: false }" [enablePersistence]="false" [filterSettings]="{ type: 'Menu' }" [selectionSettings]="{ mode: 'Both', checkboxOnly: true }"
                (created)="created($event)" (actionBegin)="onGridActionBegin($event)"
                (actionComplete)="onActionComplete($event, AddressesPopupGrid)" (toolbarClick)="onToolbarClick($event)"
                (commandClick)="commandColumnClick($event)">
                <e-columns>
                  <e-column *ngFor="let column of AddressesGridColumns;" [field]="column.field"
                    [headerText]="column.headerText"
                    [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'" [type]="column.type"
                    [width]="column.width" [filter]="column.filter ? column.filter : { type: 'Menu' }"
                    [format]="column.format ? column.format : null" [textAlign]="column.textAlign"
                    [showInColumnChooser]="column.showInColumnChooser ?? true" [visible]="column.visible"
                    [commands]="column?.commands ? column.commands : null" [edit]="column.edit"
                    [allowReordering]="column.allowReordering ?? true" [freeze]="column.freeze ? column.freeze: null"
                    [allowEditing]="column.allowEditing" [allowSorting]="column.allowSorting"
                    [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">



                    <ng-template *ngIf="column.field === 'userId'" #template let-data>
                      <a href="javascript:" (click)="openUserProfile(data)">{{data.userId}}</a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>
          </div>
        </div>


        <div class="modal-footer">
          <!-- [disabled]="!isFormUpdated || !getPermission('bpPopup_btn_save').enable" -->
          <button type="button" class="btn btn-sm btn-danger close-modal px-2" (click)="close()">Close</button>
          <!-- <button type="button"
            class="btn btn-sm btn-success close-modal px-2" (click)="saveSignature()">Save</button>
        </div> -->
        </div>
      </div>
    </div>
  </div>

  <ng-template #columnChooserForGrid>
    <app-column-chooser [grid]="AddressesPopupGrid"></app-column-chooser>
  </ng-template>

  
@if ( showUserProfilePopup ) {
  <app-user-profile-popup
  [userProfile]="userProfile"
  (closePopup)="showUserProfilePopup = false;"
  ></app-user-profile-popup>
}